import type { AppRouter } from "@ptsd/ptsd-manager-api";
import { TRPCClientError } from "@trpc/client";

export function isTRPCError(
  error: unknown,
): error is TRPCClientError<AppRouter> {
  return error instanceof TRPCClientError;
}
